import { render, staticRenderFns } from "./TestimonialsDetails.vue?vue&type=template&id=03f6108a&"
import script from "./TestimonialsDetails.vue?vue&type=script&lang=js&"
export * from "./TestimonialsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports